(function () {
  var desk = document.querySelector('.sticky-bar');
  var mob = document.getElementById('sticky-atc-bar');
  if (!desk || !mob) return;

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function deskShown() {
    return getComputedStyle(desk).display !== 'none';
  }

  function sync() {
    if (!isDesktop()) {
      mob.classList.remove('abx-desktop-paired');
      return;
    }
    var show = deskShown();
    mob.classList.toggle('abx-desktop-paired', show);
  }

  var obs = new MutationObserver(sync);
  obs.observe(desk, { attributes: true, attributeFilter: ['style', 'class'] });
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
})();
